import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import './Label.css';

export interface LabelProps extends Omit<TypographyProps, 'variant'> {
  /**
   * Label variant
   * - h1: Page title
   * - h2: Section title
   * - body: Default body text
   * - small: Small text
   */
  variant?: 'h1' | 'h2' | 'body' | 'small';
  
  /**
   * Text color
   * - primary: Default text color
   * - secondary: Secondary text color
   * - white: White text (for foreground)
   */
  color?: 'primary' | 'secondary' | 'white';
}

const Label: React.FC<LabelProps> = ({
  variant = 'body',
  color = 'primary',
  className = '',
  children,
  ...otherProps
}) => {
  const getClassName = () => {
    const classes = ['label', `label-${variant}`, `label-color-${color}`];
    
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <Typography
      variant={variant === 'h1' || variant === 'h2' ? variant : 'body1'}
      className={getClassName()}
      {...otherProps}
    >
      {children}
    </Typography>
  );
};

export default Label;

